export default "__VITE_PUBLIC_ASSET__c23b6869__"